window.onUsersnapCXLoad = function(api) {
  api.init();
};
var script = document.createElement('script');
script.defer = 1;
script.src = 'https://widget.usersnap.com/global/load/568e18ea-df5d-4563-ae97-157d1835ffc9?onload=onUsersnapCXLoad';
document.getElementsByTagName('head')[0].appendChild(script);
